import * as actions from "./../actions/actionTypes";
const initState = [];
const storeReducer = (state = initState, action) => {
  switch (action.type) {
    case actions.FETCH_STORES:
      return action.payload;
    default:
      return state;
  }
};

export default storeReducer;
